(function(){
    'use strict'

    angular
    .module('app.tiposPlanilla')
    .controller('EditarTipoPlanilla', EditarTipoPlanilla);

    EditarTipoPlanilla.$inject = ['$scope', '$animationsSrv', '$routeParams', 'TiposPlanillaService', 'PeriodosService', 'logger', '$location', 'UserInfoService', 'moment'];

    function EditarTipoPlanilla($scope, $animationsSrv, $routeParams, TiposPlanillaService, PeriodosService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tipoPlanillaId = $routeParams.id ? $routeParams.id : 0;
        vm.periodos = [];
        vm.tipoPlanilla = {
            periodoId: -1
        };

        vm.inicioPeriodoOptions = {
            showWeeks: true
          };

          vm.openInicioPeriodo = function(){
              vm.inicioPeriodoOpened = !vm.inicioPeriodoOpened;
          }

        var promisePeriodo = getPeriodos();

        if(vm.tipoPlanillaId){
            getById(promisePeriodo);
        }

        function getPeriodos(){
            var promise = PeriodosService.getAll(UserInfoService.getCompaniaId())
            .then(function(periodos){
                vm.periodos = periodos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los períodos')
            }); 
            
            return promise;
        }

        function getById(promisePeriodo){

            promisePeriodo.then(function(){
                TiposPlanillaService.getById(UserInfoService.getCompaniaId(), vm.tipoPlanillaId)
                .then(function(tipoPlanilla){
                    tipoPlanilla.periodoInicio = moment(tipoPlanilla.periodoInicio).toDate();
                    vm.tipoPlanilla = tipoPlanilla;
                })
                .catch(function(error){
                    $logger.error('Error al obtener los datos del tipo de Planilla')
                });                
            });
        }

        vm.save = function(){

            $scope.submitted = true;

            if(vm.tipoPlanilla.periodoId == -1){
                $scope.tipoPlanillaForm.periodoId.$setValidity("different", false);
            }

            if($scope.tipoPlanillaForm.$valid){
                if(!vm.tipoPlanilla.id){
                    vm.tipoPlanilla.id = 0;
                    saveTipoPlanilla();
                }
                else{
                    if($scope.tipoPlanillaForm.$dirty){
                        updateTipoPlanilla();
                    }
                    else{
                        logger.info('No has modificado ningún dato');
                    }
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        vm.periodosChange = function(){
            if(vm.tipoPlanilla.periodoId == -1){
                $scope.tipoPlanillaForm.periodoId.$setValidity("different", false);
            }
            else{
                $scope.tipoPlanillaForm.periodoId.$setValidity("different", true);
            }
        };

        function saveTipoPlanilla() {
            var promise = TiposPlanillaService.save(vm.tipoPlanilla);
                
            promise
            .then(function(response){
                logger.success('Tipo de Planilla creado con éxito.');
                clearTipoPlanillaData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un erro al crea el tipo de Planilla: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un erro al crea el tipo de Planilla');
                        break;
                }
            }); 
        }

        function updateTipoPlanilla() {
            var promise = TiposPlanillaService.update(vm.tipoPlanilla);
                
            promise
            .then(function(response){
                logger.success('Tipo de Planilla modificado con éxito.');
                $location.path('/tipos-planilla');
            })
            .catch(function(error){
                logger.error('Hubo un erro al modificar el tipo de Planilla');
            }); 
        }

        function clearTipoPlanillaData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.tipoPlanilla = {
                periodoId: -1
            };
            // Set back to pristine.
            $scope.tipoPlanillaForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.tipoPlanillaForm.$setUntouched();
        }

    }
})();